import { render } from "./giftcardbalance.vue?vue&type=template&id=56225c9e"
import script from "./giftcardbalance.vue?vue&type=script&lang=js"
export * from "./giftcardbalance.vue?vue&type=script&lang=js"

import "./giftcardbalance.vue?vue&type=style&index=0&id=56225c9e&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__